import { ProcessSupervisionFieldParams } from '@scale/shared/types/chat';

export const processCritiqueFields: ProcessSupervisionFieldParams = {
  collectForRatingValues: [1, -1],
  description: `Justify why you disagree with the critique`,
  fieldId: 'critique',
  label: 'Critique Difference Reason',
  required: true,
  type: 'plaintext',
};

interface FilterUnecessaryCritiqueFieldsProps {
  fields: any[];
  rating: number;
  currentStep: number;
  critiqueStep: number;
}

export const filterUnecessaryCritiqueFields = (props: FilterUnecessaryCritiqueFieldsProps) => {
  const { fields, rating, currentStep, critiqueStep } = props;
  // remove critique field when not needed
  const agreeWithProcessCritique =
    (rating === -1 && critiqueStep === currentStep) ||
    (rating === 1 && critiqueStep !== currentStep);
  const critiqueIdx = fields.findIndex(field => field.fieldId === 'critique');
  if (critiqueIdx !== -1) {
    if (agreeWithProcessCritique) {
      fields.splice(critiqueIdx, 1);
    } else {
      const correctOrIncorrect = critiqueStep === currentStep ? 'correct' : 'incorrect';
      const first =
        critiqueStep === -1
          ? 'There was no step that was flagged by the critique.'
          : currentStep !== critiqueStep
          ? `A different step was flagged by the critique, but not this step.`
          : `This step was flagged by the critique.`;
      const second =
        critiqueStep === -1
          ? `Please justify why you think this step is incorrect.`
          : `Please justify why you disagree with the critique and think this step is ${correctOrIncorrect}.`;
      fields[critiqueIdx].description = `${first} ${second}`;
    }
  }
};
